import { render, staticRenderFns } from "./chalkBoard.vue?vue&type=template&id=a987d552"
import script from "./chalkBoard.vue?vue&type=script&lang=js"
export * from "./chalkBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports